{
  "alert": "Įspėjimas",
  "dismiss": "Atmesti"
}